import Request from "services";
import { Endpoints } from "services/endpoints";
import {LoginRequestBody, LoginResponseData, RegisterRequestBody } from "./types";
import { handleRequestError } from "utils";

export const register = async (data: RegisterRequestBody) => {
    try {
        const response = await Request.post(Endpoints.signup, {
            data
        });
        return response;
    } catch (error) {
        handleRequestError(error)
    }
}

export const login = async (data: LoginRequestBody) => {
    try {
        const response = await Request.post<LoginResponseData>(Endpoints.login, {
            data
        });
        return response;
    } catch (error) {
        handleRequestError(error)
    }
}

export const verifyEmail = async (token: string) => {
    try {
        const response = await Request.post<LoginResponseData>(Endpoints.verifyEmail, {data: {token}});
        return response;
    } catch (error) {
        handleRequestError(error)
    }
}

export const resendVerificationMail = async (email: string) => {
    try {
        const response = await Request.postWithUserToken<LoginResponseData>(Endpoints.resendVerifyEmail(email));
        return response;
    } catch (error) {
        handleRequestError(error)
    }
}

export const requestPasswordReset = async (email: string) => {
    try {
        const response = await Request.postWithUserToken<LoginResponseData>(Endpoints.requestPasswordReset, {data: {email}});
        return response;
    } catch (error) {
        handleRequestError(error)
    }
}

export const resetPassword = async (password: string, token: string) => {
    try {
        const response = await Request.postWithUserToken<LoginResponseData>(Endpoints.resetPassword, {data: {password, token}});
        return response;
    } catch (error) {
        handleRequestError(error)
    }
}